import Socket, { Message } from '../connection/socket';
import { getState, socketListenerDispatch } from './socket-listener-main';
import { setUserMeetingSettings } from '../stores/actions/session';
import { GreenroomState } from '../stores/types/types';
import { SOCKET_MESSAGE_TYPES } from '../types/constants';
import { showAlert } from '../components/general-components/alert-service';

function kickUser(message: any) {
	const {
		SessionReducer: {
			user,
		},
	} = getState() as GreenroomState;

	if (user && message.message.email === user.email) {
		console.log(message.message.method);
		window.location.reload();
	}
}

function handleGreenroomAlert(socketMessage: any) {
	const { message } = socketMessage;
	const {
		SessionReducer: {
			host,
		},
	} = getState() as GreenroomState;

	if (!message.host || (message.host && host)) {
		showAlert({
			message: message.message,
			description: message.description,
			duration: message.duration,
			type: message.type,
		});
	}
}

function handleUserMeetingSettingsUpdate({ message }: Message) {
	socketListenerDispatch(setUserMeetingSettings(message));
}

export default function Session(socket: Socket) {
	socket.addListener('kick-user', kickUser);
	socket.addListener(SOCKET_MESSAGE_TYPES.GREENROOM_ALERT, handleGreenroomAlert);
	socket.addListener('user-meeting-settings-update', handleUserMeetingSettingsUpdate);
}
